import { createState } from '@hookstate/core';

const GlobalStates = createState({
    isLoading: true,
    isLoggedIn: false,
    
    showAlert: false,
    alertTimer: null,
    alertType: "success",
    alertTitle: "Success",
    alertBody: "Success",

    showFilterSidebar: false,
    showConfirmationModal: false,

    employeeRoles: [],
    subscriberPlans: [],
    subscriberStatuses: []
});

export default GlobalStates;